// autogramKep.js — kvalifikovaný elektronický podpis (KEP) cez lokálny Autogram (slovensko.digital).
// UMD build sa načíta ON-DEMAND z /v2/vendor/ (nie v hlavnom bundli). Podpis vzniká LOKÁLNE u používateľa
// (eID čítačka / Autogram v mobile) — Autogram beží na POČÍTAČI POUŽÍVATEĽA, nie na serveri. Mirko 2026-07-24.
// Overené research: import z with-ui buildu (global AutogramSDK.CombinedClient); PDF = PAdES, mime application/pdf;base64,
// 4. arg decodeBase64=false (inak sa binárne PDF poškodí); CORS=* (intranet OK); init() nepotrebuje appku, deteguje sa pri sign().

const SDK_URL = '/v2/vendor/autogram.with-ui.global.js'
let _loading = null

function loadSdk() {
  if (typeof window !== 'undefined' && window.AutogramSDK && window.AutogramSDK.CombinedClient) return Promise.resolve(window.AutogramSDK)
  if (_loading) return _loading
  _loading = new Promise((resolve, reject) => {
    const s = document.createElement('script')
    s.src = SDK_URL; s.async = true
    s.onload = () => (window.AutogramSDK && window.AutogramSDK.CombinedClient)
      ? resolve(window.AutogramSDK)
      : reject(new Error('Autogram SDK sa načítal, ale chýba CombinedClient.'))
    s.onerror = () => { _loading = null; reject(new Error('Nepodarilo sa načítať Autogram SDK.')) }
    document.head.appendChild(s)
  })
  return _loading
}

// PDF (URL) → base64 bez data: prefixu (bezpečné pre veľké súbory, po častiach)
export async function pdfUrlToBase64(url) {
  const r = await fetch(url, { credentials: 'same-origin' })
  if (!r.ok) throw new Error('Nepodarilo sa načítať PDF dokumentu (' + r.status + ').')
  const buf = new Uint8Array(await r.arrayBuffer())
  let bin = ''; const CH = 0x8000
  for (let i = 0; i < buf.length; i += CH) bin += String.fromCharCode.apply(null, buf.subarray(i, i + CH))
  return btoa(bin)
}

// base64 → Blob (na multipart upload podpísaného PDF)
export function base64ToBlob(b64, mime = 'application/pdf') {
  const bin = atob(String(b64 || ''))
  const u8 = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i)
  return new Blob([u8], { type: mime })
}

// Podpíš PDF (base64) cez Autogram → { content(base64 podpísaného PDF), signedBy, issuedBy, level }
export async function signPdfKep(pdfBase64, filename = 'dokument.pdf', level = 'PAdES_BASELINE_T') {
  const SDK = await loadSdk()
  const client = await SDK.CombinedClient.init()   // vytvorí SDK UI; appku ešte nepotrebuje
  try {
    const res = await client.sign(
      { content: pdfBase64, filename },
      { level, checkPDFACompliance: true },          // PAdES → BEZ container; _T = kvalifikovaný + časová pečiatka
      'application/pdf;base64',                       // ;base64 = content je base64 (binárne PDF)
      false                                           // decodeBase64 MUSÍ byť false pre binárne PDF
    )
    return { content: res.content, signedBy: res.signedBy || '', issuedBy: res.issuedBy || '', level }
  } catch (e) {
    const m = String((e && (e.message || e.name)) || '')
    if (/zru|cancel/i.test(m) || (e && /cancel/i.test(String(e.name || '')))) {
      const err = new Error('Podpisovanie zrušené.'); err.cancelled = true; throw err
    }
    if (/spustiť Autogram|Failed to fetch|NetworkError|load failed/i.test(m)) {
      throw new Error('Autogram (desktopová aplikácia) nie je spustený. Nainštaluj/spusti Autogram z autogram.slovensko.digital a skús znova.')
    }
    throw new Error(m || 'Podpisovanie zlyhalo.')
  }
}
